module.exports = __webpack_public_path__ + "images/ico-calendar.svg?fa56755081d4754218eeeae072dcb366";